import React, { FC } from 'react';

import { Svg } from '@lglp/components';

import styles from './TwitterIcon.module.scss';

const TwitterIcon: FC<TwitterIconProps> = ({ className, ...rest }) => {
  return (
    <Svg
      className={[styles.twitterIcon, className]}
      viewBox="0 0 44 44"
      {...rest}
    >
      <circle
        data-name="Ellipse 209"
        cx="22"
        cy="22"
        r="22"
        style={{ fill: '#fff' }}
      />
      <path
        data-name="twitter"
        d="M31.4 16.9a7.4 7.4 0 0 1-2.1.6 3.7 3.7 0 0 0 1.6-2 7.4 7.4 0 0 1-2.3.9 3.7 3.7 0 0 0-6.3 3.4 10.5 10.5 0 0 1-7.6-3.8 3.7 3.7 0 0 0 1.1 4.9 3.6 3.6 0 0 1-1.7-.5 3.7 3.7 0 0 0 3 3.6h-1.6a3.7 3.7 0 0 0 3.4 2.6 7.4 7.4 0 0 1-4.6 1.6h-.9a10.5 10.5 0 0 0 16.1-8.8v-.5a7.5 7.5 0 0 0 1.8-1.9"
        transform="translate(0 -1.002)"
        style={{ fill: '#003da5' }}
      />
    </Svg>
  );
};

type TwitterIconProps = {
  className?: string;
};

export default TwitterIcon;
